import styled from 'styled-components';
import Container from '../../../components/container';

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 300px;
  min-width: 300px;
  padding-top: 30px;
  padding-bottom: 30px;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    //padding: 30px;
    width: calc(${(props) => {
    switch (props.size) {
      case 4:
        return '25%';
      case 3:
        return '33%';
      case 1:
        return '100%';
      case 2:
      default:
        return '50%';
    }
  }} - 60px);
  }
`;

export const ChartFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => {
    if (props.center) {
      if (props.center === true) {
        return `
        justify-content: center;
        align-items: center;  
      `;
      }
      if (props.center === 'h') {
        return 'justify-content: center;';
      }
      if (props.center === 'v') {
        return 'align-items: center;';
      }
    }
    return 'justify-content: space-evenly;';
  }}

  ${(props) => (props.wrap ? `flex-wrap: ${props.wrap};` : null)}
`;


export const ShowOn = styled.div`
  ${(props) => `
        @media all and (${props.desktop ? 'max' : 'min'}-width: ${props.theme.breakingpoints.md}) {
          display: none;
        }
      `}
`;

export const CompareBar = styled.div`
  background-color: ${(props) => props.backgroundColor || '#F8EDF1'};
  width: 100%;
  margin-top: 3rem;
  margin-bottom: 3rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CompareBarImg = styled.img`
  padding-right: 2rem;
  height: 75px;
`;

export const CompareBarTextWrapper = styled.h3`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CompareBarText = styled.h3`
  font-size: 2rem;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => {
    if (props.center) {
      if (props.center === true) {
        return `
        justify-content: center;
        align-items: center;  
      `;
      }
      if (props.center === 'h') {
        return 'justify-content: center;';
      }
      if (props.center === 'v') {
        return 'align-items: center;';
      }
    }

    return null;
  }}

  ${(props) => (props.wrap ? `flex-wrap: ${props.wrap};` : null)}
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) => {
    if (props.center) {
      if (props.center === true) {
        return `
        justify-content: center;
        align-items: center;  
      `;
      }
      if (props.center === 'h') {
        return 'justify-content: center;';
      }
      if (props.center === 'v') {
        return 'align-items: center;';
      }
    }

    return null;
  }}

  ${(props) => (props.wrap ? `flex-wrap: ${props.wrap};` : null)}
`;

export const HPSWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    margin-top: 2rem;
    width: fit-content;
  }
`;

export const HipexScoreLabel = styled.h3`
  font-size: 2rem;
  margin-bottom: 0;
  display: flex;
  @media all and (max-width: ${(props) => props.theme.breakingpoints.md}) {
    justify-content: center;
  }
`;

export const HPSText = styled.span`
  margin-left: 1rem;
`;

export const HipexScoreScore = styled.span`
  font-size: 5rem;
  font-family: ${(props) => props.theme.fontFamilyMedium};
  margin-top: -1rem;
  // padding-left: 1.5rem;
  display: flex;
  justify-content: center;
  // display: flex;
  // justify-content: center;
`;

export const SiteTitle = styled.h1`
  color: ${(props) => props.theme.fontColor};
  margin-bottom: 1rem;
  width: calc(100vw - 2rem);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 2.25rem !important;
  
  ::first-letter {
    text-transform: uppercase;
  }

  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    width: auto;
  }
`;

export const Hero = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
  align-items: center;
  // min-height: 22.22rem;
  max-height: 100%;
  height: 100%;

  padding-bottom: 2rem;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    grid-template-columns: 1.8fr 2fr;
  }

  @media print {
    break-inside: always;
  }
`;

export const HeroLeft = styled.div`
  order: 3;
  min-width: 0;
  height: 100%;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    order: 1;
    // padding-top: 1rem;
    // padding-bottom: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    // padding-top: 7.5rem;
    // padding-bottom: 7.5rem;
  }
`;

export const HeroRight = styled.div`
  display: flex;
  justify-content: flex-end;
  order: 1;
  min-width: 0;
  padding-top: 1rem;
  padding-bottom: 1rem;
  height: 100%;
  @media print {
    display: none;
  }
  @media all and (max-width: ${(props) => props.theme.breakingpoints.md}) {
    width: 100%;
  }

  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    order: 2;
    // padding-top: 1rem;
    // padding-bottom: 1rem;
    // padding-top: 7.5rem;
    // padding-bottom: 7.5rem;
  }
`;

export const Widgets = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;
  grid-gap: 5rem;
  align-items: center;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
    grid-template-columns: 1fr 1fr;
  }
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

export const StyledContainer = styled(Container)`
  @media print {
    padding-top: 4rem;
    break-before: always;
    break-inside: avoid;
  }
`;

export const PerformanceScanWrapper = styled.section`
  margin-top: 1rem;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    margin-top: 3rem;
  }
`;
